/* useAutoScroll — keeps the conversation comfortable to read:
   - focuses the name field when the identity step appears
   - in thread mode, smooth-scrolls the active turn ~16% from the top as the
     thread grows; in page mode it resets to the top. */
import { RefObject, useEffect } from 'react';

export function useAutoScroll(
  mainRef: RefObject<HTMLDivElement>,
  idx: number,
  isPage: boolean,
  currentKind: string
): void {
  // Focus the name field when the identity step appears.
  useEffect(() => {
    if (currentKind !== 'identity') return;
    const root = mainRef.current;
    const f = root?.querySelector(
      '.intake-turn[data-active="true"] .intake-id-first, .intake-conv .intake-id-first'
    ) as HTMLElement | null;
    if (f) f.focus({ preventScroll: true });
  }, [idx, currentKind]);

  // Keep the active turn comfortably in view as the thread grows.
  useEffect(() => {
    const root = mainRef.current;
    if (!root) return;
    if (isPage) {
      root.scrollTop = 0;
      return;
    }
    const active = root.querySelector('.intake-turn[data-active="true"]') as HTMLElement | null;
    if (!active) return;
    const coach = (active.querySelector('.intake-coach') as HTMLElement) || active;
    const rc = coach.getBoundingClientRect();
    const rm = root.getBoundingClientRect();
    const delta = rc.top - rm.top - rm.height * 0.16;
    try {
      root.scrollTo({ top: root.scrollTop + delta, behavior: 'smooth' });
    } catch (e) {
      root.scrollTop += delta;
    }
  }, [idx, isPage]);
}
